import { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { captureUtm } from "@/lib/utm";
import LandingPage from "@/pages/LandingPage";
import AdminPage from "@/pages/AdminPage";
import ContactPage from "@/pages/ContactPage";

function App() {
  useEffect(() => {
    captureUtm();
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="noise-overlay" aria-hidden="true" />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <Toaster theme="light" position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
